import { History } from "history";

import {
  CreateSubjectNoteRequest,
  SubjectNoteDto,
  PaginateQuery,
  UpdateSubjectNoteRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get Subject Notes

export const GET_SUBJECT_NOTES = "GET_SUBJECT_NOTES";
export const GET_SUBJECT_NOTES_SUCCESS: any = "GET_SUBJECT_NOTES_SUCCESS";
export const GET_SUBJECT_NOTES_ERROR: any = "GET_SUBJECT_NOTES_ERROR";

export interface GetSubjectNotesAction {
  type: typeof GET_SUBJECT_NOTES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetSubjectNotesSuccessAction {
  type: typeof GET_SUBJECT_NOTES_SUCCESS;
  payload: Paginated<SubjectNoteDto>;
}

export interface GetSubjectNotesErrorAction {
  type: typeof GET_SUBJECT_NOTES_ERROR;
  payload: any;
}
//#endregion

//#region Get Subject Note

export const GET_SUBJECT_NOTE = "GET_SUBJECT_NOTE";
export const GET_SUBJECT_NOTE_SUCCESS: any = "GET_SUBJECT_NOTE_SUCCESS";
export const GET_SUBJECT_NOTE_ERROR: any = "GET_SUBJECT_NOTE_ERROR";

export interface GetSubjectNoteAction {
  type: typeof GET_SUBJECT_NOTE;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetSubjectNoteSuccessAction {
  type: typeof GET_SUBJECT_NOTE_SUCCESS;
  payload: SubjectNoteDto;
}

export interface GetSubjectNoteErrorAction {
  type: typeof GET_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

//#region Add Subject Note

export const ADD_SUBJECT_NOTE = "ADD_SUBJECT_NOTE";
export const ADD_SUBJECT_NOTE_SUCCESS: any = "ADD_SUBJECT_NOTE_SUCCESS";
export const ADD_SUBJECT_NOTE_ERROR: any = "ADD_SUBJECT_NOTE_ERROR";

export interface AddSubjectNoteAction {
  type: typeof ADD_SUBJECT_NOTE;
  payload: {
    request: CreateSubjectNoteRequest;
    history: History;
  };
}

export interface AddSubjectNoteSuccessAction {
  type: typeof ADD_SUBJECT_NOTE_SUCCESS;
  payload: null;
}

export interface AddSubjectNoteErrorAction {
  type: typeof ADD_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

//#region Update Subject Note

export const UPDATE_SUBJECT_NOTE = "UPDATE_SUBJECT_NOTE";
export const UPDATE_SUBJECT_NOTE_SUCCESS: any = "UPDATE_SUBJECT_NOTE_SUCCESS";
export const UPDATE_SUBJECT_NOTE_ERROR: any = "UPDATE_SUBJECT_NOTE_ERROR";

export interface UpdateSubjectNoteAction {
  type: typeof UPDATE_SUBJECT_NOTE;
  payload: {
    id: string;
    request: UpdateSubjectNoteRequest;
    history: History;
  };
}

export interface UpdateSubjectNoteSuccessAction {
  type: typeof UPDATE_SUBJECT_NOTE_SUCCESS;
  payload: null;
}

export interface UpdateSubjectNoteErrorAction {
  type: typeof UPDATE_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

//#region Delete Subject Note

export const DELETE_SUBJECT_NOTE_CONSENT: any = "DELETE_SUBJECT_NOTE_CONSENT";
export const DELETE_SUBJECT_NOTE = "DELETE_SUBJECT_NOTE";
export const DELETE_SUBJECT_NOTE_SUCCESS: any = "DELETE_SUBJECT_NOTE_SUCCESS";
export const DELETE_SUBJECT_NOTE_ERROR: any = "DELETE_SUBJECT_NOTE_ERROR";

export interface DeleteSubjectNoteConsentAction {
  type: typeof DELETE_SUBJECT_NOTE_CONSENT;
  payload: string;
}

export interface DeleteSubjectNoteAction {
  type: typeof DELETE_SUBJECT_NOTE;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteSubjectNoteSuccessAction {
  type: typeof DELETE_SUBJECT_NOTE_SUCCESS;
  payload: null;
}

export interface DeleteSubjectNoteErrorAction {
  type: typeof DELETE_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Subject Note State

export const TOGGLE_SUBJECT_NOTE_STATE_CONSENT: any =
  "TOGGLE_SUBJECT_NOTE_STATE_CONSENT";
export const TOGGLE_SUBJECT_NOTE_STATE = "TOGGLE_SUBJECT_NOTE_STATE";
export const TOGGLE_SUBJECT_NOTE_STATE_SUCCESS: any =
  "TOGGLE_SUBJECT_NOTE_STATE_SUCCESS";
export const TOGGLE_SUBJECT_NOTE_STATE_ERROR: any =
  "TOGGLE_SUBJECT_NOTE_STATE_ERROR";

export interface ToggleSubjectNoteStateConsentAction {
  type: typeof TOGGLE_SUBJECT_NOTE_STATE_CONSENT;
  payload: string;
}

export interface ToggleSubjectNoteStateAction {
  type: typeof TOGGLE_SUBJECT_NOTE_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleSubjectNoteStateSuccessAction {
  type: typeof TOGGLE_SUBJECT_NOTE_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleSubjectNoteStateErrorAction {
  type: typeof TOGGLE_SUBJECT_NOTE_STATE_ERROR;
  payload: any;
}
//#endregion

//#region Upload Subject Note

export const UPLOAD_SUBJECT_NOTE = "UPLOAD_SUBJECT_NOTE";
export const UPLOAD_SUBJECT_NOTE_SUCCESS: any = "UPLOAD_SUBJECT_NOTE_SUCCESS";
export const UPLOAD_SUBJECT_NOTE_ERROR: any = "UPLOAD_SUBJECT_NOTE_ERROR";

export interface UploadSubjectNoteAction {
  type: typeof UPLOAD_SUBJECT_NOTE;
  payload: {
    file: File;
    id?: string | null;
  };
}
export interface UploadSubjectNoteSuccessAction {
  type: typeof UPLOAD_SUBJECT_NOTE_SUCCESS;
  payload: MediaDto;
}

export interface UploadSubjectNoteErrorAction {
  type: typeof UPLOAD_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

//#region add edit Subject Note modal
export const TOGGLE_ADD_EDIT_SUBJECT_NOTE_MODAL: any =
  "TOGGLE_ADD_EDIT_SUBJECT_NOTE_MODAL";
export interface ToggleAddEditSubjectNoteModalAction {
  type: typeof TOGGLE_ADD_EDIT_SUBJECT_NOTE_MODAL;
  payload: any;
}
//#endregion

//#region Get Subject Notes

export const DOWNLOAD_SUBJECT_NOTE = "DOWNLOAD_SUBJECT_NOTE";
export const DOWNLOAD_SUBJECT_NOTE_SUCCESS: any =
  "DOWNLOAD_SUBJECT_NOTE_SUCCESS";
export const DOWNLOAD_SUBJECT_NOTE_ERROR: any = "DOWNLOAD_SUBJECT_NOTE_ERROR";

export interface DownloadSubjectNoteAction {
  type: typeof DOWNLOAD_SUBJECT_NOTE;
  payload: { id: string };
}

export interface DownloadSubjectNoteSuccessAction {
  type: typeof DOWNLOAD_SUBJECT_NOTE_SUCCESS;
  payload: any;
}

export interface DownloadSubjectNoteErrorAction {
  type: typeof DOWNLOAD_SUBJECT_NOTE_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSubjectNotesAction
  | GetSubjectNotesSuccessAction
  | GetSubjectNotesErrorAction
  | GetSubjectNoteAction
  | GetSubjectNoteSuccessAction
  | GetSubjectNoteErrorAction
  | AddSubjectNoteAction
  | AddSubjectNoteSuccessAction
  | AddSubjectNoteErrorAction
  | UpdateSubjectNoteAction
  | UpdateSubjectNoteSuccessAction
  | UpdateSubjectNoteErrorAction
  | DeleteSubjectNoteConsentAction
  | DeleteSubjectNoteAction
  | DeleteSubjectNoteSuccessAction
  | DeleteSubjectNoteErrorAction
  | ToggleSubjectNoteStateConsentAction
  | ToggleSubjectNoteStateAction
  | ToggleSubjectNoteStateSuccessAction
  | ToggleSubjectNoteStateErrorAction
  | UploadSubjectNoteAction
  | UploadSubjectNoteSuccessAction
  | UploadSubjectNoteErrorAction
  | ToggleAddEditSubjectNoteModalAction
  | DownloadSubjectNoteAction
  | DownloadSubjectNoteSuccessAction
  | DownloadSubjectNoteErrorAction;
